import React from 'react';
import { StyledButton } from './StyledButton';

interface IProps {
  children: React.ReactNode;
  style?: any;
  handleClick: () => void;
  startIcon?: any;
  disabled?: boolean;
  variant?: 'contained' | 'outlined';
}

const CustomButton = ({
  children,
  style,
  handleClick,
  startIcon,
  disabled,
  variant = 'contained',
}: IProps) => {
  return (
    <StyledButton
      disabled={disabled}
      onClick={handleClick}
      variant={variant}
      size="small"
      sx={{ ...style }}
      startIcon={startIcon}>
      {children}
    </StyledButton>
  );
};

export default CustomButton;
